<input type="text" [(ngModel)]="phoneNumber" [placeholder]="inputMask"
       (blur)="onBlur($event)" (select)="onTextSelected($event)" (click)="onClick($event)" (keyup)="onKeyUp($event)" (keypress)="checkInput($event)" (paste)="phonePasted($event)" [disabled]="isDisabled"/>

